/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalsignin_Link_Toast_TitleInputs */

const en_portalsignin_link_toast_title = /** @type {(inputs: Portalsignin_Link_Toast_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-in links are not connected yet`)
};

/** @type {(inputs: Portalsignin_Link_Toast_TitleInputs) => LocalizedString} */
const ar_portalsignin_link_toast_title = en_portalsignin_link_toast_title;

/** @type {(inputs: Portalsignin_Link_Toast_TitleInputs) => LocalizedString} */
const he_portalsignin_link_toast_title = en_portalsignin_link_toast_title;

/** @type {(inputs: Portalsignin_Link_Toast_TitleInputs) => LocalizedString} */
const ur_portalsignin_link_toast_title = en_portalsignin_link_toast_title;

/** @type {(inputs: Portalsignin_Link_Toast_TitleInputs) => LocalizedString} */
const es_portalsignin_link_toast_title = en_portalsignin_link_toast_title;

/** @type {(inputs: Portalsignin_Link_Toast_TitleInputs) => LocalizedString} */
const fr_portalsignin_link_toast_title = en_portalsignin_link_toast_title;

/** @type {(inputs: Portalsignin_Link_Toast_TitleInputs) => LocalizedString} */
const de_portalsignin_link_toast_title = en_portalsignin_link_toast_title;

/** @type {(inputs: Portalsignin_Link_Toast_TitleInputs) => LocalizedString} */
const pt_portalsignin_link_toast_title = en_portalsignin_link_toast_title;

/** @type {(inputs: Portalsignin_Link_Toast_TitleInputs) => LocalizedString} */
const hi_portalsignin_link_toast_title = en_portalsignin_link_toast_title;

/** @type {(inputs: Portalsignin_Link_Toast_TitleInputs) => LocalizedString} */
const bn_portalsignin_link_toast_title = en_portalsignin_link_toast_title;

/**
* | output |
* | --- |
* | "Sign-in links are not connected yet" |
*
* @param {Portalsignin_Link_Toast_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalsignin_link_toast_title = /** @type {((inputs?: Portalsignin_Link_Toast_TitleInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalsignin_Link_Toast_TitleInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalsignin_link_toast_title(inputs)
	if (locale === "he") return he_portalsignin_link_toast_title(inputs)
	if (locale === "ur") return ur_portalsignin_link_toast_title(inputs)
	if (locale === "es") return es_portalsignin_link_toast_title(inputs)
	if (locale === "fr") return fr_portalsignin_link_toast_title(inputs)
	if (locale === "de") return de_portalsignin_link_toast_title(inputs)
	if (locale === "pt") return pt_portalsignin_link_toast_title(inputs)
	if (locale === "hi") return hi_portalsignin_link_toast_title(inputs)
	if (locale === "bn") return bn_portalsignin_link_toast_title(inputs)
	return /** @type {LocalizedString} */ ("Sign-in links are not connected yet")
});